import { useNavigate } from "react-router";

import { getComboTitle } from "@datanac/datanac-api-toolkit/dist/insurance/optimizer/optimizer";
import { useDialog } from "@datanac/datanac-mui-toolkit";
import { Chip } from "@mui/material";
import { InsuranceIcon } from "components/Icons/Icons";
import { formatPracticeName, formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";

export default function InsuranceCountyPracticeCard({ insuranceScenario, budgetCountyPractice }) {
  const navigate = useNavigate();

  const handleCardNavigateClick = () => {
    if (insuranceScenario?.id && budgetCountyPractice.state_name) {
      navigate(
        `/insurance/${insuranceScenario?.id}/${budgetCountyPractice.state_name}/${budgetCountyPractice.county_name}/${budgetCountyPractice.commodity_name}/${budgetCountyPractice.type_name}/${budgetCountyPractice.practice_name}`
      );
    }
  };

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  return (
    <>
      <TilleyCard
        data-testid={`Open-${budgetCountyPractice?.county_name}-${budgetCountyPractice?.state_name}`}
        onClick={handleCardNavigateClick}
        Avatar={InsuranceIcon}
        title={`${budgetCountyPractice?.commodity_name + " - " + formatPracticeName(budgetCountyPractice?.practice_name)}`}
        subtitle={budgetCountyPractice?.name ?? <>&nbsp;</>}
        details={[
          {
            value: formatPrice(budgetCountyPractice?.totals?.producer_premium_amount_per_acre, 2),
            label: "PRODUCER PREMIUM /ac",
          },
          {
            value: formatPrice(budgetCountyPractice?.totals?.liability_amount_per_acre, 0),
            label: "COVERAGE /ac",
          },
        ]}
        footer={
          <>
            {budgetCountyPractice?.insurancePlans?.map((currentInsurancePlan, index) => (
              <Chip key={index} label={getComboTitle([currentInsurancePlan])} />
            ))}
          </>
        }
      />

      {confirmDialogComponent}
    </>
  );
}
